import { render, staticRenderFns } from "./EditVhostDialog.vue?vue&type=template&id=a737084c&scoped=true&"
import script from "./EditVhostDialog.vue?vue&type=script&lang=ts&"
export * from "./EditVhostDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a737084c",
  null
  
)

export default component.exports